import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Nav, Row, Col, Form, Button, Modal, ButtonGroup, DropdownButton, // Accordion,
Dropdown } from "react-bootstrap";
import { Stack, Switch, FormControlLabel, debounce } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { ModalAllder } from "layouts/ModalAllder";
import { TagsInput } from "react-tag-input-component";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { nanoid } from "nanoid";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import { useReactToPrint } from "react-to-print";
import "styles/print.css";
import { getDiscountValue, NumberFormat, filterTextAndNum, getPrefixName, WDA } from "utils/HelperFunction";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, // DragOverlay,
MouseSensor, TouchSensor } from "@dnd-kit/core";
// import { NumericFormat } from "react-number-format";
import { COMPANY_LOGO } from "constants/server/api";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { // arrayMove,
SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { billing } from "../../redux/handlers/billing/billing.handler";
import { getBillingByID } from "../../redux/handlers/billing/getBillingByID.handler";
export function Billing() {
    var dispatch = useAppDispatch();
    var businessID = null;
    var memID = null;
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                    memID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.mb_mem_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), tabStatus = _useState2[0], setTabStatus = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var billingReducer = useAppSelector(function(state) {
        return state.billingReducer;
    });
    useEffect(function() {
        setIsLoading(billingReducer.isFetching);
        if (billingReducer.data) {
            var data = billingReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        billingReducer
    ]);
    useEffect(function() {
        dispatch(billing(tabStatus == 0 ? null : parseInt(tabStatus), parseInt(businessID), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        tabStatus
    ]);
    useEffect(function() {
        if (filterText) {
            setRowData(filteredItems.filter(function(item) {
                return item.bl_billing_code && item.bl_billing_code.toLowerCase().includes(filterText.toLowerCase()) || item.bl_billing_name && item.bl_billing_name.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        rowData,
        filterText
    ]);
    var columns = [
        {
            name: "เลขที่ใบแจ้งหนี้",
            selector: function(row) {
                return row.bl_billing_code;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/billing/edit/" + row.bl_billing_id,
                        children: row.bl_billing_code ? row.bl_billing_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "อ้างอิงใบเสนอราคา",
            selector: function(row) {
                return row.QrQuotation ? row.QrQuotation.qr_quotation_code : "-";
            },
            center: "true",
            width: "160px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/quotation",
                        children: row.QrQuotation ? row.QrQuotation.qr_quotation_code : "-"
                    })
                });
            }
        },
        {
            name: "ชื่อกิจการ",
            selector: function(row) {
                return row.bl_billing_businesstype ? row.bl_billing_businesstype == 1 ? row.bl_billing_fname ? row.bl_billing_fname + " " + row.bl_billing_lname : "-" : row.bl_billing_name ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.bl_billing_name,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.bl_billing_taxid
                        })
                    ]
                }) : "-" : "-";
            },
            width: "200px"
        },
        {
            name: "สาขา",
            selector: function(row) {
                return row.bl_billing_businesstype == 2 ? row.bl_billing_branchname ? row.bl_billing_branchname : "-" : "-";
            }
        },
        {
            name: "ยอดเงิน (บาท)",
            selector: function(row) {
                return NumberFormat(row.bl_billing_totalnet, 2);
            },
            right: true
        },
        {
            name: "รอบการชำระ",
            selector: function(row) {
                return row.bl_billing_expiredate ? moment(row.bl_billing_expiredate).format("DD/MM/YYYY") : "-";
            },
            center: "true"
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.bl_billing_issuedate ? moment(row.bl_billing_issuedate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "วันที่กำหนดชำระ",
            selector: function(row) {
                return row.bl_billing_expiredate ? moment(row.bl_billing_expiredate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.bl_billing_status;
            },
            center: "true",
            // width: "150px",
            cell: function(row, index, column, id) {
                return row.bl_billing_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ร่างแบบ"
                }) || row.bl_billing_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.bl_billing_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติแล้ว"
                }) || row.bl_billing_status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.bl_billing_status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                }) || row.bl_billing_status == 6 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgb(247 9 236)",
                        backgroundColor: "rgb(248 229 251)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รับชำระ"
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบแจ้งหนี้"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: "ใบแจ้งหนี้"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatus,
                        onSelect: function(selectedKey) {
                            return setTabStatus(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: "รอชำระ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: "อนุมัติแล้ว"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "6",
                                    children: "ชำระแล้ว"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "4",
                                    children: "ยกเลิก"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 7,
                                            children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                                data: rowData,
                                                filename: "ใบแจ้งหนี้"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 5,
                                            children: /*#__PURE__*/ _jsx(Stack, {
                                                direction: "horizontal",
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "ค้นหาเลขใบแจ้งหนี้",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(DataTableLayout, {
                                item: rowData,
                                columns: columns,
                                isSelectRows: false,
                                PerPage: 10
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export function BillingCreate() {
    var schema = yup.object().shape({});
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var accessToken = localStorage.getItem("accessToken");
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), formdisabled = _useState1[0], setFormdisabled = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), stepper = _useState2[0], setStepper = _useState2[1];
    var _useState3 = _sliced_to_array(useState(new Date()), 2), docDate = _useState3[0], setDocDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState(new Date()), 2), dueDate = _useState4[0], setDueDate = _useState4[1];
    var _useState5 = _sliced_to_array(useState(new Date()), 2), payDate = _useState5[0], setPayDate = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), supplierInfos = _useState6[0], setSupplierInfos = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), tabStatus = _useState7[0], setTabStatus = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), productRow = _useState8[0], setProductRow = _useState8[1];
    var _useState9 = _sliced_to_array(useState(1), 2), statusPage = _useState9[0], setstatusPage = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), sumrowNoDiscount = _useState10[0], setSumrowNoDiscount = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), sumrowBeforeVat = _useState11[0], setSumrowBeforeVat = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState12[0], setSumrowTotalNet = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), sumrowQty = _useState13[0], setSumrowQty = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), sumrowPrice = _useState14[0], setSumrowPrice = _useState14[1];
    var _useState15 = _sliced_to_array(useState(0), 2), sumrowDiscount = _useState15[0], setSumrowDiscount = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), sumDiscount = _useState16[0], setSumDiscount = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), sumrowVat = _useState17[0], setSumrowVat = _useState17[1];
    var _useState18 = _sliced_to_array(useState(0), 2), sumrowTax = _useState18[0], setSumrowTax = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), docPath = _useState19[0], setDocPath = _useState19[1];
    var _useState20 = _sliced_to_array(useState([]), 2), docPathDel = _useState20[0], setDocPathDel = _useState20[1];
    var _useState21 = _sliced_to_array(useState([]), 2), productRowDel = _useState21[0], setProductRowDel = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), tagselected = _useState22[0], setTagSelected = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), remark = _useState23[0], setRemark = _useState23[1];
    var _useState24 = _sliced_to_array(useState(true), 2), taxSwitch = _useState24[0], setTaxSwitch = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), payment = _useState25[0], setPayment = _useState25[1];
    var _useState26 = _sliced_to_array(useState([]), 2), invoice = _useState26[0], setInvoice = _useState26[1];
    var _useState27 = _sliced_to_array(useState(false), 2), modalsuccess = _useState27[0], setModalsuccess = _useState27[1];
    var _useState28 = _sliced_to_array(useState(false), 2), textsuccess = _useState28[0], setTextsuccess = _useState28[1];
    var _useState29 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState29[0], setPartnerInfo = _useState29[1];
    var _useState30 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState30[0], setColumDisplay = _useState30[1];
    var _useState31 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 550,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalPay = _useState31[0], setModalPay = _useState31[1];
    var _useState32 = _sliced_to_array(useState({
        bl_billing_memid: "",
        bl_billing_issuedate: moment(new Date()).format("DD/MM/YYYY"),
        bl_billing_expiredate: moment(new Date()).format("DD/MM/YYYY"),
        bl_billing_paytype: 1,
        bl_billing_vattype: 1,
        bl_billing_discounttype: 1,
        bl_billing_discount: "",
        bl_billing_status: 1,
        bl_billing_vat: 0,
        bl_billing_tax: 0
    }), 2), formData = _useState32[0], setFormData = _useState32[1];
    var dataSteps1 = [
        "สร้างใบเสร็จ",
        "รออนุมัติ",
        "เสร็จสิ้น"
    ];
    var dataSteps2 = [
        "สร้างใบเสร็จ",
        "รออนุมัติ",
        "รับชำระ",
        "ชำระแล้วบางส่วน",
        "เสร็จสิ้น"
    ];
    var optionsMstPaymentType = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    var optionsMstPriceType = [
        {
            value: 1,
            label: "รวมภาษี"
        },
        {
            value: 2,
            label: "ไม่รวมภาษี"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var getBillingByIDReducer = useAppSelector(function(state) {
        return state.getBillingByIDReducer;
    });
    useEffect(function() {
        setIsLoading(getBillingByIDReducer.isFetching);
        if (dataID) {
            if (getBillingByIDReducer.data) {
                var dataBill = getBillingByIDReducer.data.data;
                console.log("getBillingByIDReducer", dataBill);
                setFormData(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        bl_billing_id: dataBill.bl_billing_id,
                        bl_billing_code: dataBill.bl_billing_code,
                        bl_billing_refer: dataBill.QrQuotation ? dataBill.QrQuotation.qr_quotation_code : "",
                        bl_billing_issuedate: dataBill.bl_billing_issuedate ? moment(dataBill.bl_billing_issuedate).format("DD/MM/YYYY") : "",
                        bl_billing_expiredate: dataBill.bl_billing_expiredate ? moment(dataBill.bl_billing_expiredate).format("DD/MM/YYYY") : "",
                        bl_billing_paytype: dataBill.bl_billing_paytype ? dataBill.bl_billing_paytype : 1,
                        bl_billing_vattype: dataBill.bl_billing_vattype ? dataBill.bl_billing_vattype : 1,
                        bl_billing_totalprice: dataBill.bl_billing_totalprice ? dataBill.bl_billing_totalprice : 0,
                        bl_billing_discounttype: dataBill.bl_billing_discounttype ? dataBill.bl_billing_discounttype : 1,
                        bl_billing_discount: dataBill.bl_billing_discount ? dataBill.bl_billing_discount : 0,
                        bl_billing_status: dataBill.bl_billing_status ? dataBill.bl_billing_status : 1,
                        bl_billing_refercode: dataBill.bl_billing_refercode ? dataBill.bl_billing_refercode : "",
                        bl_billing_totalnet: dataBill.bl_billing_totalnet ? dataBill.bl_billing_totalnet : 0,
                        bl_billing_totalpay: dataBill.bl_billing_totalpay ? dataBill.bl_billing_totalpay : 0,
                        bl_billing_tax: dataBill.bl_billing_tax,
                        bl_billing_vat: dataBill.bl_billing_vat,
                        bl_billing_totalvat: dataBill.bl_billing_totalvat ? dataBill.bl_billing_totalvat : 0,
                        bl_billing_totaltax: dataBill.bl_billing_totaltax ? dataBill.bl_billing_totaltax : 0
                    });
                });
                setFormdata({
                    bl_billing_quotid: dataBill.bl_billing_quotid ? dataBill.bl_billing_quotid : "",
                    bl_billing_status: dataBill.bl_billing_status ? dataBill.bl_billing_status : 1,
                    bl_billing_refercode: dataBill.bl_billing_refercode ? dataBill.bl_billing_refercode : "",
                    bl_billing_categoryid: dataBill.bl_billing_categoryid,
                    bl_billing_suffixname: dataBill.bl_billing_suffixname,
                    bl_billing_vatcode: dataBill.bl_billing_vatcode,
                    bl_billing_name: dataBill.bl_billing_name,
                    bl_billing_address: dataBill.bl_billing_address,
                    bl_billing_fname: dataBill.bl_billing_fname,
                    bl_billing_lname: dataBill.bl_billing_lname,
                    bl_billing_mainfname: dataBill.bl_billing_mainfname,
                    bl_billing_mainlname: dataBill.bl_billing_mainlname,
                    bl_billing_mainphone: dataBill.bl_billing_mainphone,
                    bl_billing_mainemail: dataBill.bl_billing_mainemail,
                    bl_billing_provinceid: dataBill.bl_billing_provinceid,
                    bl_billing_subprovinceid: dataBill.bl_billing_subprovinceid,
                    bl_billing_zipcodeid: dataBill.bl_billing_zipcodeid,
                    bl_billing_districtid: dataBill.bl_billing_districtid,
                    bl_billing_comprefixid: dataBill.bl_billing_comprefixid,
                    bl_billing_comprefixname: dataBill.bl_billing_comprefixname,
                    bl_billing_taxid: dataBill.bl_billing_taxid,
                    bl_billing_businesstype: dataBill.bl_billing_businesstype,
                    bl_billing_branchname: dataBill.bl_billing_branchname,
                    bl_billing_memid: dataBill.bl_billing_memid,
                    bl_billing_tax: dataBill.bl_billing_tax,
                    bl_billing_vat: dataBill.bl_billing_vat,
                    bl_billing_totalvat: dataBill.bl_billing_totalvat ? dataBill.bl_billing_totalvat : 0,
                    bl_billing_totaltax: dataBill.bl_billing_totaltax ? dataBill.bl_billing_totaltax : 0
                });
                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                    companyName: dataBill.bl_billing_businesstype == 2 ? filterTextAndNum(dataBill.bl_billing_comprefixname ? dataBill.bl_billing_comprefixname : "") + filterTextAndNum(dataBill.bl_billing_name ? dataBill.bl_billing_name : "") + filterTextAndNum(dataBill.bl_billing_suffixname ? dataBill.bl_billing_suffixname : "") : filterTextAndNum(dataBill.bl_billing_prefixid == 1 && "นาย" || dataBill.bl_billing_prefixid == 2 && "นาง" || dataBill.bl_billing_prefixid == 3 && "นางสาว" || dataBill.bl_billing_prefixid == 4 && "ไม่ระบุ" || dataBill.bl_billing_prefixid == "" && "") + " " + filterTextAndNum(dataBill.bl_billing_fname) + " " + filterTextAndNum(dataBill.bl_billing_lname),
                    companyBranch: dataBill.bl_billing_branchname ? dataBill.bl_billing_branchname : "",
                    companyTaxId: dataBill.bl_billing_taxid ? dataBill.bl_billing_taxid : "",
                    companyAddress: dataBill.bl_billing_address,
                    companyProvince: dataBill.Billprovinceid ? JSON.parse(dataBill.Billprovinceid.province_name).th : "",
                    companyDistrict: dataBill.Billdistrictid ? JSON.parse(dataBill.Billdistrictid.subdistrict_name).th : "",
                    companySubDistrict: dataBill.Billsubprovinceid ? JSON.parse(dataBill.Billsubprovinceid.district_name).th : "",
                    companyZipCode: dataBill.bl_billing_zipcodeid ? dataBill.bl_billing_zipcodeid : "",
                    contractName: dataBill.bl_billing_mainfname && dataBill.bl_billing_mainlname ? dataBill.bl_billing_mainfname + " " + dataBill.bl_billing_mainlname : "",
                    contactPhone: dataBill.bl_billing_mainphone ? dataBill.bl_billing_mainphone : "",
                    contactEmail: dataBill.bl_billing_mainemail ? dataBill.bl_billing_mainemail : ""
                }));
                var arrFile = [];
                dataBill === null || dataBill === void 0 ? void 0 : dataBill.BlFile.map(function(ele) {
                    return arrFile.push({
                        id: nanoid(),
                        bl_file_url: ele.bl_file_url,
                        type: "update",
                        bl_file_id: ele.bl_file_id
                    });
                });
                setDocPath(arrFile);
                var datalistData = [];
                dataBill.BlDetail.map(function(ele) {
                    return datalistData.push({
                        rowID: nanoid(),
                        bl_detail_amount: ele.bl_detail_amount ? ele.bl_detail_amount : 0,
                        bl_detail_billid: ele.bl_detail_billid ? ele.bl_detail_billid : "",
                        bl_detail_id: ele.bl_detail_id ? ele.bl_detail_id : "",
                        bl_detail_discount: ele.bl_detail_discount ? ele.bl_detail_discount : 0,
                        bl_detail_discountreal: ele.bl_detail_discountreal ? ele.bl_detail_discountreal : 0,
                        bl_detail_discounttype: ele.bl_detail_discounttype ? ele.bl_detail_discounttype : 1,
                        bl_detail_name: ele.bl_detail_name ? ele.bl_detail_name : "",
                        bl_detail_net: ele.bl_detail_net ? ele.bl_detail_net : 0,
                        bl_detail_price: ele.bl_detail_price ? ele.bl_detail_price : 0,
                        bl_detail_pricediscount: ele.bl_detail_pricediscount ? ele.bl_detail_pricediscount : 0,
                        bl_detail_remark: ele.bl_detail_remark ? ele.bl_detail_remark : "",
                        bl_detail_tax: ele.bl_detail_tax ? ele.bl_detail_tax : 0,
                        bl_detail_taxtype: ele.bl_detail_taxtype ? ele.bl_detail_taxtype : 0,
                        bl_detail_totalprice: ele.bl_detail_totalprice ? ele.bl_detail_totalprice : 0,
                        bl_detail_unit: ele.bl_detail_unit ? ele.bl_detail_unit : "",
                        bl_detail_vat: ele.bl_detail_vat ? ele.bl_detail_vat : 0,
                        bl_detail_vatnet: ele.bl_detail_vatnet ? ele.bl_detail_vatnet : 0,
                        bl_detail_vatprice: ele.bl_detail_vatprice ? ele.bl_detail_vatprice : 0,
                        type: "update"
                    });
                });
                setProductRow(datalistData);
                if (dataBill.InvInvoice.length > 0) {
                    var pay = [];
                    dataBill.InvInvoice.map(function(ele) {
                        return pay.push({
                            id: nanoid(),
                            inv_invoice_paytype: ele.inv_invoice_paytype,
                            inv_invoice_totalnet: ele.inv_invoice_totalnet,
                            inv_invoice_ramark: ele.inv_invoice_ramark,
                            inv_invoice_taxstatus: ele.inv_invoice_taxinvoice,
                            inv_invoice_issuedate: ele.inv_invoice_issuedate
                        });
                    });
                    setPayment(pay);
                } else {
                    var pay1 = [];
                    pay1.push({
                        id: nanoid(),
                        inv_invoice_issuedate: moment().format("DD/MM/YYYY"),
                        inv_invoice_paytype: 1,
                        inv_invoice_totalnet: dataBill.bl_billing_totalnet + dataBill.bl_billing_totalvat - dataBill.bl_billing_totaltax,
                        inv_invoice_ramark: "",
                        inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
                        type: "create"
                    });
                    setPayment(pay1);
                }
                setInvoice(dataBill.InvInvoice);
                setSumDiscount(dataBill.bl_billing_discounttype == 1 ? dataBill.bl_billing_discount : dataBill.bl_billing_totalprice * dataBill.bl_billing_discount / 100);
                setstatusPage(dataBill.bl_billing_status ? dataBill.bl_billing_status : 1);
                setStepper(dataBill.bl_billing_status ? dataBill.bl_billing_status : 1);
                setDocDate(new Date(dataBill.bl_billing_issuedate));
                setDueDate(new Date(dataBill.bl_billing_expiredate));
                setSumrowTotalNet(dataBill.bl_billing_totalprice);
                setSumrowTax(dataBill.bl_billing_totaltax);
                setSumrowVat(dataBill.bl_billing_totalvat);
            }
        }
    }, [
        getBillingByIDReducer
    ]);
    useEffect(function() {
        //   dispatch(getAllMstBusiness());
        setModalsuccess(false);
        if (dataID) {
            dispatch(getBillingByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        dataID
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/billing",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบแจ้งหนี้"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: !dataID ? "สร้างใบแจ้งหนี้" : "ใบแจ้งหนี้"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: !dataID ? "สร้างใบแจ้งหนี้" : "ใบแจ้งหนี้"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("values", values);
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handleSubmit();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3 pagezoom",
                                        children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
                                            dataLabel: formData.bl_billing_status == 3 ? dataSteps2 : dataSteps1,
                                            activeStep: stepper
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "pt-3 px-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เลขที่ใบแจ้งหนี้"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_code",
                                                                            value: formData.bl_billing_code,
                                                                            className: "form-control",
                                                                            placeholder: "IV-2410000001",
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: docDate,
                                                                            onChange: function(date) {
                                                                                setDocDate(date);
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_issuedate: moment(date).format("DD/MM/YYYY")
                                                                                }));
                                                                            },
                                                                            disabled: true,
                                                                            className: "w-100 datepicker2",
                                                                            value: formData.bl_billing_issuedate
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "วันที่ครบกำหนด"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ครบกำหนด",
                                                                            selected: dueDate,
                                                                            onChange: function(date) {
                                                                                setDueDate(date);
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_expiredate: moment(date).format("DD/MM/YYYY")
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            disabled: true,
                                                                            value: formData.bl_billing_expiredate
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิงระบบ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_refer",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิงระบบ",
                                                                            value: formData.bl_billing_refer,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_refercode",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิง",
                                                                            value: formData.bl_billing_refercode,
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_refercode: e.target.value
                                                                                })); // Update formData state
                                                                            },
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            style: {
                                                                                zIndex: 11
                                                                            },
                                                                            children: [
                                                                                "ผู้จัดจำหน่าย",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            value: partnerInfo.companyName,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ประเภทราคา"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "bl_billing_vattype",
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_vattype: e.value
                                                                                }));
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            options: optionsMstPriceType,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: optionsMstPriceType.filter(function(item) {
                                                                                return item.value === formData.bl_billing_vattype;
                                                                            }),
                                                                            isDisabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ประเภทการชำระเงิน"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "bl_billing_paytype",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกประเภทการชำระเงิน",
                                                                                options: optionsMstPaymentType,
                                                                                value: optionsMstPaymentType.filter(function(item) {
                                                                                    return item.value === formData.bl_billing_paytype;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bl_billing_paytype: e.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ผู้จัดทำเอกสาร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "creBy",
                                                                            className: "form-control",
                                                                            placeholder: "admim",
                                                                            value: "-",
                                                                            onChange: handleChange,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: partnerInfo.companyName
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: [
                                                                                            "สาขา : ",
                                                                                            partnerInfo.companyBranch
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: [
                                                                                            "ทะเบียนนิติบุคคล :",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-5",
                                                                                                children: partnerInfo.companyTaxId
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-18 mb-2",
                                                                                children: "-"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companyAddress
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companySubDistrict + " " + partnerInfo.companyDistrict
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: "-"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ข้อมูลผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: partnerInfo.contractName && partnerInfo.contractName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "ชื่อ : ",
                                                                                                partnerInfo.contractName
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "เบอร์โทรศัพท์ : ",
                                                                                                partnerInfo.contactPhone
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "อีเมล : ",
                                                                                                partnerInfo.contactEmail
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: "-"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "pagezoom",
                                        children: /*#__PURE__*/ _jsxs(Nav, {
                                            variant: "pills",
                                            defaultActiveKey: tabStatus,
                                            onSelect: function(selectedKey) {
                                                return setTabStatus(selectedKey);
                                            },
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: "1",
                                                        children: "ข้อมูลสินค้า"
                                                    })
                                                }),
                                                statusPage >= 3 && /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: "2",
                                                        children: "การรับชำระ"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tabStatus == 1 && /*#__PURE__*/ _jsx(ProductData, {
                                        formdisabled: formdisabled,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        values: values,
                                        errors: errors,
                                        setFieldValue: setFieldValue,
                                        handleChange: handleChange,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        sumrowNoDiscount: sumrowNoDiscount,
                                        setSumrowNoDiscount: setSumrowNoDiscount,
                                        sumrowQty: sumrowQty,
                                        setSumrowQty: setSumrowQty,
                                        sumrowPrice: sumrowPrice,
                                        setSumrowPrice: setSumrowPrice,
                                        sumrowDiscount: sumrowDiscount,
                                        setSumrowDiscount: setSumrowDiscount,
                                        sumrowBeforeVat: sumrowBeforeVat,
                                        setSumrowBeforeVat: setSumrowBeforeVat,
                                        sumrowTotalNet: sumrowTotalNet,
                                        setSumrowTotalNet: setSumrowTotalNet,
                                        sumDiscount: sumDiscount,
                                        setSumDiscount: setSumDiscount,
                                        sumrowVat: sumrowVat,
                                        setSumrowVat: setSumrowVat,
                                        sumrowTax: sumrowTax,
                                        setSumrowTax: setSumrowTax,
                                        columdisplay: columdisplay,
                                        dataID: dataID,
                                        setFormData: setFormData,
                                        formData: formData,
                                        tagselected: tagselected,
                                        setTagSelected: setTagSelected,
                                        setRemark: setRemark,
                                        docPath: docPath,
                                        setDocPath: setDocPath,
                                        docPathDel: docPathDel,
                                        setDocPathDel: setDocPathDel,
                                        setIsLoading: setIsLoading,
                                        setModalObj: setModalObj,
                                        modalObj: modalObj,
                                        remark: remark,
                                        productRowDel: productRowDel,
                                        setProductRowDel: setProductRowDel
                                    }),
                                    tabStatus == 2 && /*#__PURE__*/ _jsx("div", {
                                        className: "row gx-xl-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "col-12",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "card pagezoom card-st-3 mb-4",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "card-body px-xl-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "pt-3 px-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-8",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-26 py-3 fw-bold",
                                                                                    children: [
                                                                                        "ข้อมูลการรับชำระใบแจ้งหนี้เลขที่",
                                                                                        " ",
                                                                                        formData.bl_billing_code ? formData.bl_billing_code : "-"
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col tc-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        children: "อ้างอิงเลขที่สัญญา"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-2",
                                                                                        children: formData.bl_billing_refercode ? formData.bl_billing_refercode : "-"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col tc-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        children: "อ้างอิงใบเสนอราคา"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-2",
                                                                                        children: formData.bl_billing_refer ? formData.bl_billing_refer : "-"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-2",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "pt-3 px-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "col-6 tc-6",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: "มูลค่าเต็มใบแจ้งหนี้ :"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet + formData.bl_billing_totalvat - formData.bl_billing_totaltax, 2),
                                                                                                " ",
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: "มูลค่าสุทธิที่ต้องชำระทั้งสิ้น :"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            style: {
                                                                                                color: "#2DC76D"
                                                                                            },
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet + formData.bl_billing_totalvat - formData.bl_billing_totaltax, 2),
                                                                                                " ",
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: "มูลค่าที่ชำระแล้ว 0 รายการ :"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalpay, 2),
                                                                                                " ",
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "col-6 pl-10",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-24 pt-2 pt-3 tc-6",
                                                                                            children: "มูลค่าที่รอชำระ"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "tc-5 fs-24",
                                                                                            style: {
                                                                                                background: "#F6E1E3",
                                                                                                padding: "12px 20px",
                                                                                                borderRadius: "8px",
                                                                                                fontWeight: 500,
                                                                                                paddingLeft: 80
                                                                                            },
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet + formData.bl_billing_totalvat - formData.bl_billing_totaltax, 2),
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        statusPage == 3 && /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2 tc-8",
                                                                                            children: [
                                                                                                "วันที่ครบกำหนด :",
                                                                                                " ",
                                                                                                formData.bl_billing_expiredate
                                                                                            ]
                                                                                        }),
                                                                                        statusPage == 3 && /*#__PURE__*/ _jsx(Button, {
                                                                                            className: "btn btn-dg",
                                                                                            style: {
                                                                                                fontSize: 20
                                                                                            },
                                                                                            onClick: function() {
                                                                                                return setModalPay(function(prev) {
                                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                                        open: true
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            children: "ชำระเงิน"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                formData.bl_billing_totalpay == formData.bl_billing_totalnet && /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                            style: {
                                                                                                color: "#B00412",
                                                                                                fontSize: 35
                                                                                            }
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-24 tc-8 fw-bold ml-2",
                                                                                            children: "ชำระเต็มจำนวน"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                invoice.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                    className: "card pagezoom card-st-3 mb-4",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "card-body px-xl-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "pt-3 px-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-12",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-20 fw-bold",
                                                                                children: "การรับชำระเงิน"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-2",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            payment.map(function(ele, i) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "pt-3 px-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-2",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 fw-bold pt-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                            style: {
                                                                                                color: "#B00412",
                                                                                                fontSize: 35
                                                                                            }
                                                                                        }),
                                                                                        " ",
                                                                                        "ชำระเงินครั้งที่ ",
                                                                                        i + 1
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-10"
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col-6 ",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-3 tc-6",
                                                                                        children: "เงินสด"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "fs-20 pt-3 tc-6",
                                                                                        children: [
                                                                                            "วันที่ชำระเงิน",
                                                                                            " ",
                                                                                            moment(ele.inv_invoice_issuedate).format("DD/MM/YYYY")
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-6",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 tc-6 pt-3",
                                                                                    children: [
                                                                                        NumberFormat(ele.inv_invoice_totalnet, 2),
                                                                                        " ",
                                                                                        "บาท"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }, i);
                                                            }),
                                                            /*#__PURE__*/ _jsx("hr", {
                                                                className: "my-4",
                                                                style: {
                                                                    opacity: 0.1
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(Stack, {
                                                                direction: "row",
                                                                justifyContent: "flex-end",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pt-3 px-3 mb-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "fs-20 tc-6 me-5",
                                                                            children: "มูลค่าที่รับชำระ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("span", {
                                                                            className: "fs-24 tc-6 text-white py-3 pr-3",
                                                                            style: {
                                                                                background: "#B00412",
                                                                                borderRadius: 10,
                                                                                paddingLeft: 100
                                                                            },
                                                                            children: [
                                                                                NumberFormat(formData.bl_billing_totalpay, 2),
                                                                                " ",
                                                                                "บาท"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ModalAllder, {
                                        modal: modalPay,
                                        setModal: setModalPay,
                                        htitle: "การรับชำระเงิน",
                                        hbtn: true,
                                        children: /*#__PURE__*/ _jsx(Payment, {
                                            values: values,
                                            payDate: payDate,
                                            setPayDate: setPayDate,
                                            setFieldValue: setFieldValue,
                                            payment: payment,
                                            setModal: setModalPay,
                                            setPayment: setPayment,
                                            taxSwitch: taxSwitch,
                                            formData: formData,
                                            setIsLoading: setIsLoading,
                                            setModalObj: setModalObj,
                                            modalObj: modalObj,
                                            setTextsuccess: setTextsuccess,
                                            setModalsuccess: setModalsuccess,
                                            setTaxSwitch: setTaxSwitch,
                                            dataID: dataID
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                display: "none"
                                            },
                                            children: /*#__PURE__*/ _jsx(PRPrint, {
                                                innerRef: componentRef
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/billing");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ยกเลิก"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: dataID ? null : "/product"
            })
        ]
    });
}
function ProductData(param) {
    var formdisabled = param.formdisabled, productRow = param.productRow, setProductRow = param.setProductRow, values = param.values, optionsMstDiscountType = param.optionsMstDiscountType, sumrowTotalNet = param.sumrowTotalNet, setSumrowTotalNet = param.setSumrowTotalNet, sumDiscount = param.sumDiscount, setSumDiscount = param.setSumDiscount, setSumrowNoDiscount = param.setSumrowNoDiscount, sumrowQty = param.sumrowQty, setSumrowQty = param.setSumrowQty, sumrowPrice = param.sumrowPrice, setSumrowPrice = param.setSumrowPrice, sumrowDiscount = param.sumrowDiscount, setSumrowDiscount = param.setSumrowDiscount, sumrowBeforeVat = param.sumrowBeforeVat, setSumrowBeforeVat = param.setSumrowBeforeVat, sumrowVat = param.sumrowVat, setSumrowVat = param.setSumrowVat, sumrowTax = param.sumrowTax, setSumrowTax = param.setSumrowTax, columdisplay = param.columdisplay, dataID = param.dataID, setFormData = param.setFormData, formData = param.formData, setTagSelected = param.setTagSelected, setDocPathDel = param.setDocPathDel, docPathDel = param.docPathDel, tagselected = param.tagselected, remark = param.remark, setRemark = param.setRemark, docPath = param.docPath, setDocPath = param.setDocPath, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, productRowDel = param.productRowDel, setProductRowDel = param.setProductRowDel;
    var _useState = _sliced_to_array(useState(true), 2), collapse = _useState[0], setCollapse = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), customSort = _useState1[0], setCustomSort = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), rowCount = _useState2[0], setRowCount = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState3[0], setOptionsWarehouse = _useState3[1];
    var dispatch = useAppDispatch();
    var _useState4 = _sliced_to_array(useState(""), 2), textImg = _useState4[0], setTextImg = _useState4[1];
    // const handlePreviewFile = (e) => {
    //   if (e.target.files[0]) {
    //     const formData = new FormData();
    //     formData.append("upload_tmp_billing", e.target.files[0]);
    //     dispatch(uploadBilling(formData, { modalObj, setModalObj }));
    //     setTextImg("doc");
    //   }
    // };
    // const uploadBillingReducer = useAppSelector(
    //   (state) => state.uploadBillingReducer
    // );
    // useEffect(() => {
    //   if (textImg == "doc") {
    //     setIsLoading(uploadBillingReducer.isFetching);
    //     if (uploadBillingReducer.data) {
    //       console.log("uploadBillingReducer", uploadBillingReducer.data.data);
    //       setDocPath((prev) => [
    //         ...prev,
    //         {
    //           id: nanoid(),
    //           bl_file_url: uploadBillingReducer.data.data,
    //           type: "create",
    //         },
    //       ]);
    //       setTextImg("");
    //     }
    //   }
    // }, [uploadBillingReducer]);
    var deleteDocument = function(removeId, item) {
        setDocPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                bl_file_id: item.bl_file_id
            };
            setDocPathDel(_to_consumable_array(docPathDel).concat([
                del
            ]));
        }
    };
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 1200,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState5[0], setModal = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-sort"
    }), 2), modalSort = _useState6[0], setModalSort = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState7[0], setModalLoadDocument = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDisplayColumn = _useState8[0], setModalDisplayColumn = _useState8[1];
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var optionsMstVat = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ];
    var optionsMstTax = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ];
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        bl_detail_name: "",
                        bl_detail_unit: "",
                        bl_detail_amount: "",
                        bl_detail_price: 0,
                        bl_detail_discounttype: 1,
                        bl_detail_discount: 0,
                        bl_detail_discountreal: 0,
                        bl_detail_pricediscount: 0,
                        bl_detail_vat: 0,
                        bl_detail_vatprice: 0,
                        bl_detail_net: "",
                        bl_detail_remark: "",
                        is_checked: false,
                        bl_detail_totalprice: 0,
                        bl_detail_vatnet: 0,
                        bl_detail_taxtype: 0,
                        bl_detail_tax: 0,
                        type: "create"
                    }
                ]);
            });
        }
    };
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceVat = 0;
        var ums = 0;
        var discount = 0;
        var pricetax = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.bl_detail_amount);
            var productPrice = parseFloat(pd.bl_detail_price);
            var productDiscount = parseFloat(pd.bl_detail_discount);
            var productVat = parseFloat(pd.bl_detail_vatprice);
            var productTax = parseFloat(pd.bl_detail_tax);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productPrice * productQty;
            }
            if (hasValidPrice) {
                price += productPrice;
                discount += productDiscount;
            }
            if (hasValidQty && hasValidPrice) {
                priceBeforeVat += (productPrice - productDiscount) * productQty;
                priceVat += productVat;
                pricetax += productTax;
            }
            setSumrowNoDiscount(ums);
            setSumrowQty(qty);
            setSumrowPrice(price);
            setSumrowDiscount(discount);
            setSumrowBeforeVat(priceBeforeVat);
            setSumrowTotalNet(priceVat && pricetax && parseFloat(priceBeforeVat + priceVat - pricetax) || priceVat && parseFloat(priceBeforeVat + priceVat) || pricetax && parseFloat(priceBeforeVat - pricetax) || priceBeforeVat && parseFloat(priceBeforeVat));
        // setSumrowVat(priceVat);
        // setSumrowTax(pricetax);
        });
    };
    useEffect(function() {
        // setRowCount(productRow.length);
        sumQty(productRow);
    }, [
        productRow
    ]);
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(1);
        }
    }, []);
    var onDeleteProductRow = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(item) {
                return item.rowID !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                bl_detail_id: item.bl_detail_id
            };
            setProductRowDel(_to_consumable_array(productRowDel).concat([
                del
            ]));
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                style: {
                    overflowX: "auto",
                    maxWidth: "100%",
                    overflowY: "hidden",
                    paddingBottom: "20px"
                },
                children: /*#__PURE__*/ _jsx(DndContext, {
                    sensors: sensors,
                    collisionDetection: closestCenter,
                    modifiers: [
                        restrictToVerticalAxis
                    ],
                    children: /*#__PURE__*/ _jsx(SortableContext, {
                        items: productRow,
                        strategy: verticalListSortingStrategy,
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "column_resize_table table1 table-striped ",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 200
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#666CFF] !text-white",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#666CFF] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#B00412] !text-white",
                                                children: "ราคา/หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#B00412] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 110
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่าก่อนภาษี"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่ารวมสุทธิ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หมายเหตุ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {}),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: productRow.map(function(item, index) {
                                        return /*#__PURE__*/ _jsx(Productrow, {
                                            item: item,
                                            index: index,
                                            setProductRow: setProductRow,
                                            columdisplay: columdisplay,
                                            customSort: customSort,
                                            rowCount: rowCount,
                                            addProductRow: addProductRow,
                                            optionsWarehouse: optionsWarehouse,
                                            optionsMstDiscountType: optionsMstDiscountType,
                                            optionsMstVat: optionsMstVat,
                                            optionsMstTax: optionsMstTax,
                                            setFormData: setFormData,
                                            formData: formData,
                                            values: values,
                                            onDeleteProductRow: onDeleteProductRow
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tfoot", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prQty",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowQty, 0),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prPrict",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowPrice, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prDiscount",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prBeforeVat",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowBeforeVat, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prTotalNet",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowTotalNet, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3",
                children: /*#__PURE__*/ _jsxs("fieldset", {
                    disabled: formdisabled,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-3 pagezoom",
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3 me-3",
                                onClick: function() {
                                    return addProductRow(1);
                                },
                                disabled: true,
                                children: "เพิ่มแถว"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "bl_billing_discount",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: formData.bl_billing_discount,
                                                                                                    onChange: function(e) {
                                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                            bl_billing_discount: e.target.value
                                                                                                        }));
                                                                                                        setSumDiscount(formData.bl_billing_discounttype == 1 ? e.target.value : sumrowTotalNet * e.target.value / 100);
                                                                                                    },
                                                                                                    // sumrowTotalNet
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    disabled: true
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "bl_billing_discounttype",
                                                                                                    onChange: function(e) {
                                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                            bl_billing_discounttype: e.value
                                                                                                        }));
                                                                                                        setSumDiscount(e.value == 1 ? formData.bl_billing_discount : sumrowTotalNet * formData.bl_billing_discount / 100);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2",
                                                                                                    options: optionsMstDiscountType,
                                                                                                    placeholder: "",
                                                                                                    value: optionsMstDiscountType.filter(function(item) {
                                                                                                        return item.value === formData.bl_billing_discounttype;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    },
                                                                                                    isDisabled: true
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2 pt-2",
                                                                                            children: "ภาษีมูลค่าเพิ่ม"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "bl_billing_vat",
                                                                                            onChange: function(e) {
                                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                    bl_billing_vat: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowVat(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstVat,
                                                                                            value: optionsMstVat.filter(function(item) {
                                                                                                return item.value === formData.bl_billing_vat;
                                                                                            }),
                                                                                            isDisabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowVat, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "หัก ณ ที่จ่าย"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "bl_billing_tax",
                                                                                            onChange: function(e) {
                                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                    bl_billing_tax: e.value
                                                                                                }));
                                                                                                var total = sumrowTotalNet - sumDiscount;
                                                                                                setSumrowTax(total * e.value / 100);
                                                                                            },
                                                                                            options: optionsMstTax,
                                                                                            value: optionsMstTax.filter(function(item) {
                                                                                                return item.value === formData.bl_billing_tax;
                                                                                            }),
                                                                                            isDisabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                                    className: "form-control text-end",
                                                                                    style: {
                                                                                        width: "120px",
                                                                                        borderBottomWidth: "1px"
                                                                                    },
                                                                                    readOnly: true,
                                                                                    disabled: true,
                                                                                    value: NumberFormat(sumrowTax, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2 text-end",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white text-end fs-24",
                                                                style: {
                                                                    background: "#B00412",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            value: remark,
                                                                            disabled: true,
                                                                            style: {
                                                                                backgroundColor: "rgb(255 255 255 / 12%)"
                                                                            },
                                                                            onChange: function(e) {
                                                                                return setRemark(e.target.value);
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagsInput, {
                                                                            value: tagselected,
                                                                            onChange: setTagSelected,
                                                                            disabled: true,
                                                                            style: {
                                                                                backgroundColor: "rgb(255 255 255 / 12%)"
                                                                            },
                                                                            name: "tag",
                                                                            placeHolder: ""
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                disabled: true,
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                disabled: true
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: docPath.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                to: item.bl_file_url,
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "docfile",
                                                                                    children: /*#__PURE__*/ _jsx("span", {
                                                                                        className: "icon pdf",
                                                                                        children: item.bl_file_url.substring(68)
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id, item);
                                                                                },
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionsMstTax = _param.optionsMstTax, setSumrowQty = _param.setSumrowQty, dataID = _param.dataID, onDeleteProductRow = _param.onDeleteProductRow, setFormData = _param.setFormData, formData = _param.formData, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionsMstTax",
        "setSumrowQty",
        "dataID",
        "onDeleteProductRow",
        "setFormData",
        "formData"
    ]);
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    value: item.bl_detail_name,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_name: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    value: item.bl_detail_unit,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_unit: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF]",
                style: {
                    color: "#666CFF"
                },
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    disabled: true,
                    className: "form-control formv text-center border-0 me-2 !bg-[#EDEDFF]",
                    value: item.bl_detail_amount,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_amount: parseInt(e.target.value),
                                        bl_detail_totalprice: parseFloat((item.bl_detail_price - item.bl_detail_discount) * e.target.value),
                                        bl_detail_net: parseFloat((item.bl_detail_price - item.bl_detail_discount) * e.target.value)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#F6E1E3]",
                style: {
                    color: "#B00412"
                },
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2 !bg-[#F6E1E3]",
                    disabled: true,
                    value: item.bl_detail_price,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_price: parseFloat(e.target.value),
                                        bl_detail_totalprice: parseFloat((e.target.value - (item === null || item === void 0 ? void 0 : item.bl_detail_discount)) * (item === null || item === void 0 ? void 0 : item.bl_detail_amount)),
                                        bl_detail_net: parseFloat((e.target.value - (item === null || item === void 0 ? void 0 : item.bl_detail_discount)) * (item === null || item === void 0 ? void 0 : item.bl_detail_amount))
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#F6E1E3]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.bl_detail_discount,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_discount: parseFloat(e.target.value),
                                        bl_detail_discountreal: parseFloat(e.target.value),
                                        bl_detail_pricediscount: parseFloat((item.bl_detail_price - e.target.value) * item.bl_detail_amount),
                                        bl_detail_totalprice: parseFloat((item.bl_detail_price - e.target.value) * item.bl_detail_amount),
                                        bl_detail_net: parseFloat((item.bl_detail_price - e.target.value) * item.bl_detail_amount)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? NumberFormat(item.bl_detail_totalprice) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? NumberFormat(item.bl_detail_net) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.bl_detail_remark,
                    disabled: true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_remark: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                style: {
                    width: "20px"
                },
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "btn btn-delete-file ",
                    onClick: function(e) {
                        return onDeleteProductRow(item.rowID, item);
                    },
                    disabled: true
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
export function Payment(param) {
    var setPayDate = param.setPayDate, payDate = param.payDate, values = param.values, setFieldValue = param.setFieldValue, setPayment = param.setPayment, payment = param.payment, taxSwitch = param.taxSwitch, formData = param.formData, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setTaxSwitch = param.setTaxSwitch, setModal = param.setModal, dataID = param.dataID;
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธนาคาร"
        },
        {
            value: 3,
            label: ""
        }
    ];
    var onClickModelPay = function() {
        var data = {
            bl_billing_id: parseInt(dataID),
            inv_invoice_issuedate: moment(payDate).format("YYYY-MM-DD") + "T00:00:00.000Z",
            inv_invoice_paytype: payment[0].inv_invoice_paytype,
            inv_invoice_ramark: payment[0].inv_invoice_ramark,
            inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
            inv_invoice_totalnet: payment[0].inv_invoice_totalnet
        };
        console.log("data", data);
    // dispatch(createbybilling(data, { modalObj, setModalObj }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3 !bg-[rgb(176 3 18)]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-9",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "fs-24 fw-bold pt-3",
                            children: [
                                "รับชำะเงิน ",
                                formData.bl_billing_code
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-3",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "วันที่ออกเอกสาร "
                                }),
                                /*#__PURE__*/ _jsx(DatePicker, {
                                    inputFormat: "DD/MM/YYYY",
                                    disabled: true,
                                    selected: payDate,
                                    onChange: function(date) {
                                        setPayDate(date);
                                    },
                                    placeholder: "DD/MM/YYYY",
                                    className: "w-100 datepicker2",
                                    value: payDate ? moment(payDate).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-2",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-12 mb-3",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 tc-5 fw-bold",
                        children: "รายการชำระเงิน"
                    })
                })
            }),
            payment.map(function(item, index) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-xl-4",
                    keys: index,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-4 col-md-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-1",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fs-20 fw-bold pt-3",
                                            children: [
                                                index + 1,
                                                "."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-11",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เอกสาร"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    placeholder: "เลือกเอกสาร",
                                                    name: "inv_invoice_paytype",
                                                    onChange: function(e) {
                                                        setPayment(function(prev) {
                                                            return prev.map(function(el) {
                                                                return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                    inv_invoice_paytype: e.value
                                                                }) : el;
                                                            });
                                                        });
                                                    },
                                                    className: "w-100 select-st-1",
                                                    options: optionsMstPayment,
                                                    value: optionsMstPayment.filter(function(d) {
                                                        return d.value == item.inv_invoice_paytype;
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-3 col-md-3",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "จำนวนเงินที่ชำระ"
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        name: "inv_invoice_totalnet",
                                        className: "form-control",
                                        placeholder: "จำนวนเงินที่ชำระ",
                                        value: NumberFormat(item.inv_invoice_totalnet, 2),
                                        disabled: true,
                                        onChange: function(e) {
                                            setPayment(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        inv_invoice_totalnet: e.target.value
                                                    }) : el;
                                                });
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-4 col-md-4",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "หมายเหตุ"
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        name: "inv_invoice_ramark",
                                        className: "form-control",
                                        placeholder: "หมายเหตุ",
                                        value: item.inv_invoice_ramark,
                                        onChange: function(e) {
                                            setPayment(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        inv_invoice_ramark: e.target.value
                                                    }) : el;
                                                });
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                });
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-4",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-3 col-md-11",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-24 fw-bold tc-5 mb-3",
                                children: "หัก ณ ที่จ่าย"
                            }),
                            /*#__PURE__*/ _jsx(Form.Group, {
                                children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                    control: /*#__PURE__*/ _jsx(Switch, {
                                        defaultChecked: taxSwitch,
                                        onChange: function(e) {
                                            setTaxSwitch(taxSwitch == true ? false : true); // Update formData state
                                        }
                                    }),
                                    label: ""
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-4",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-5 col-md-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-4 col-md-1",
                        children: /*#__PURE__*/ _jsx(Stack, {
                            direction: "row",
                            justifyContent: "flex-end",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "tc-6 text-white py-3 px-3 !bg-[#B00412] mt-2",
                                style: {
                                    borderRadius: 10
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "fs-20 me-10",
                                        children: "รับชำระเงินรวมทั้งสิน"
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "fs-24 ",
                                        children: [
                                            NumberFormat(formData.bl_billing_totalnet ? formData.bl_billing_totalnet + formData.bl_billing_totalvat - formData.bl_billing_totaltax : 0, 2),
                                            " ",
                                            "บาท"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-end",
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 me-3 btn py-1 px-5 mt-4",
                                style: {
                                    height: " 50px"
                                },
                                onClick: function(e) {
                                    onClickModelPay();
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "mt-4 btn btn-dg",
                                onClick: function(e) {
                                    onClickModelPay();
                                },
                                children: "ยืนยันชำระเงิน"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export function PRPrint(param) {
    var innerRef = param.innerRef, values = param.values, companyInfo = param.companyInfo;
    var maxRowPerPage = 10;
    var _useState = _sliced_to_array(useState(), 2), prow = _useState[0], setProw = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), page = _useState1[0], setPage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), tmpRow = _useState2[0], setTmpRow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), warehouses = _useState3[0], setWarehouses = _useState3[1];
    var _useState4 = _sliced_to_array(useState(), 2), qrBase64 = _useState4[0], setQrBase64 = _useState4[1];
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    useEffect(function() {
        setTmpRow(0);
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        ref: innerRef,
        children: prow && prow.map(function(item, index) {
            return /*#__PURE__*/ _jsx(PagePrint, {
                primaryData: values,
                warehouses: warehouses,
                pageCur: index + 1,
                pageAll: prow.length,
                pdata: item,
                tmpRow: tmpRow,
                maxRowPerPage: maxRowPerPage,
                qrBase64: qrBase64,
                companyInfo: companyInfo
            }, index);
        })
    });
}
var PagePrint = function(param) {
    var primaryData = param.primaryData, pageCur = param.pageCur, pageAll = param.pageAll, pdata = param.pdata, tmpRow = param.tmpRow, maxRowPerPage = param.maxRowPerPage, warehouses = param.warehouses, qrBase64 = param.qrBase64, companyInfo = param.companyInfo;
    return /*#__PURE__*/ _jsx("div", {
        className: "text-[10.5px] text-[#2C2C2C] mb-1",
        style: {
            width: "210mm",
            height: "297mm",
            padding: "5px 30px",
            margin: "0",
            background: "white",
            position: "relative"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: " flex text-[10.5px] items-end mb-3",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-start mr-auto mt-3 ",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mr-[15px]",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: COMPANY_LOGO,
                            className: "w-[58px]"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-bold ",
                                children: "(สำนักงานใหญ่)"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "",
                                children: "เลขผู้เสียภาษี / Tax ID"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mr-2",
                                        children: "Tel: (สำนักงานใหญ่)"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {})
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
